import { forwardRef, type ComponentProps } from "react";
import { cn } from "@/lib/utils";

type FloatingTextareaProps = Omit<ComponentProps<"textarea">, "placeholder"> & {
  id: string;
  label: string;
  error?: string;
};

export const FloatingTextarea = forwardRef<HTMLTextAreaElement, FloatingTextareaProps>(
  function FloatingTextarea({ id, label, error, className, ...props }, ref) {
    const errorId = `${id}-error`;

    return (
      <div>
        <div className="home-float-textarea-wrap relative">
          <textarea
            {...props}
            ref={ref}
            id={id}
            placeholder=" "
            aria-invalid={error ? true : undefined}
            aria-describedby={error ? errorId : undefined}
            className={cn("home-float-input home-float-textarea", className)}
          />
          <label htmlFor={id} className="home-float-label">
            {label} *
          </label>
        </div>
        {error ? (
          <p id={errorId} className="mt-1.5 text-[14px] leading-snug text-home-error">
            {error}
          </p>
        ) : null}
      </div>
    );
  },
);
